import './SevicesPage.scss';
import React from 'react';
import ContactUs from '../../Components/Mersa/ContactUs/ContactUs';
import SectionServices from '../../Components/Mersa/SectionServices/SectionServices';
import ServicesVideo from '../../Components/Mersa/ServicesVideo/ServicesVideo';
import ServicesDescription from '../ServicesDescription/ServicesDescription';
import { Helmet } from 'react-helmet';
import { getServices } from '../../Network/home';
import { useQuery } from '@tanstack/react-query';
const SevicesPage = ({ t }) => {
  const { data: dataServices, isLoading } = useQuery({
    queryKey: ['getServices'],
    queryFn: () => getServices(),
  });
  return (
    <div className="sevices-page">
      <Helmet>
        <title>Services - Merse</title>
      </Helmet>
      <SectionServices
        t={t}
        titleBtn={t.ContactUs}
        data={dataServices?.data?.services}
        isLoading={isLoading}
      />
      <ServicesVideo t={t} />
      <ServicesDescription t={t} />
      <ContactUs t={t} />
    </div>
  );
};

export default SevicesPage;
